import React, { createContext, useContext, useMemo } from 'react';

import type { GlobalFilters, UseFilters } from './hooks';
import { INITIAL_FILTERS, useFilters } from './hooks';

export type FilterContextValues = UseFilters;

export const defaultValue = {
  filters: INITIAL_FILTERS as GlobalFilters,
  applyFilter: (): void => {},
  applyTableFilter: (): void => {},
  clearTableFilters: (): void => {},
  loading: true,
  shareableId: null,
  selectedCustomFilter: null,
  applyCustomFilter: (): void => {},
};

export const FilterContext = createContext<FilterContextValues>(defaultValue);

type Props = {
  children: React.ReactNode;
};

export const useFiltersContext = (): FilterContextValues => useContext(FilterContext);

const FilterProvider = ({ children }: Props): JSX.Element => {
  const {
    filters,
    applyFilter,
    applyTableFilter,
    clearTableFilters,
    loading,
    shareableId,
    selectedCustomFilter,
    applyCustomFilter,
  } = useFilters();

  const memoizedContextValue = useMemo(
    () => ({
      filters,
      applyFilter,
      applyTableFilter,
      clearTableFilters,
      loading,
      shareableId,
      selectedCustomFilter,
      applyCustomFilter,
    }),
    [
      filters,
      applyFilter,
      applyTableFilter,
      clearTableFilters,
      loading,
      shareableId,
      selectedCustomFilter,
      applyCustomFilter,
    ]
  );

  return <FilterContext.Provider value={memoizedContextValue}>{children}</FilterContext.Provider>;
};

export default FilterProvider;
